@if (sessions$ | async; as sessions) {
  <section lvCloseOverlay withKeyboard="esc">
    <header>
      <h2 translate>session-review.component.title</h2>
      <img src="assets/lv-brand.svg" alt="LearnerVerified" />
    </header>

    @if (sessions.length) {
      <div class="body">
        <lv-session-review-id [session]="sessions[0]"></lv-session-review-id>
        <lv-session-review-attendance [sessions]="sessions"></lv-session-review-attendance>
      </div>
    } @else {
      <div class="body content">
        <p translate>session-review.component.nothing-yet</p>
      </div>
    }
  </section>
}
